export function dateTimeEndValidator(value: any, params: any[] | Record<string, any>) {
  const dateTimeEnd = (params as { [key: string]: boolean }).dateTimeEnd
  const dateTimeEndErrorMessage = (params as { [key: string]: string }).dateTimeEndErrorMessage
  if (dateTimeEnd === true) {
    return false
  } else {
    return true
  }
}
